<template>
  <div class="baby_barn_page">
    <!-- 最大的有内容区-->
    <div class="baby_barn_content">
      <div class="content_top" ref="content_top"
      @click.stop="hiddenEle"
      @scroll="handleScroll">
        <div class="baby_barn_story">
          <div class="header" ref="header">
            <div class="header_l">
              <Title>
                <h3 class="title">当前库存</h3>
              </Title>
            </div>
          </div>
          <!-- 悬浮按钮 -->
          <span class="gobackBtn" @click.stop="goBack">
            <img src="./../../../../assets/images/icon/back1.png" class="backimg" alt />
          </span>
          <!-- 不为空的库存 -->
          <div class="all_tab">
            <span v-for="(item, idx) in kcTabs" :class="kcCur == item.id ? 'cur_active' : ''"
            @click.stop="kcTabChange(item.id, item.sign)"
            :key="idx">{{item.tit}}({{item.total}})</span>
          </div>
          <div class="current_inventory" v-if="isMilkInventor">
            <ul class="inventory_list">
              <li
                v-for="(item, idx) in sliceMilkInventorData"
                :key="idx"
                :class="['inventory_item', 'left_slider']"
                ref="inventory_item"
              >
              <van-swipe-cell
              @open="leftSliderFn(item.id)"
              @close="rightSliderFn(item.id)"
              :ref="`list${item.id}`">
                <van-card>
                  <template #tags>
                    <dl class="dl"
                    ref="dl">
                    <dt class="brand_img">
                      <div class="brand_img_bor">
                        <div class="pic">
                        <img
                        :src="item.pic ? item.pic : require('./../../../../assets/images/feedRecord/add.png')"
                        alt="飞鹤奶粉"
                        />
                      </div>
                      </div>
                    </dt>
                      <dd class="brand_explain">
                        <div class="title">
                          <h6>{{item.productName}}</h6>
                        </div>
                        <div class="tips">
                          <div class="weight">
                            <span class="remind" v-if="(item.using && item.productDan == grading) && (item.num <= 2 || item.eatDays <= 7)"><font>余粮不足</font></span>
                            <span class="specification">{{item.specs}}g</span>
                            <span class="balance" v-if="(item.using && item.productDan == grading)">还能再吃<small>{{ item.eatDays > 0 ? item.eatDays : 0}}</small>天</span>
                          </div>
                        </div>
                        <div class="eat_days">
                          <!-- 当前在吃 -->
                          <div class="eat" v-if="(item.using && item.productDan == grading)">
                            <div class="img" v-if="item.num > 0">
                              <img src="./../../../../assets/images/feedRecord/eat_checked.svg" alt="">
                            </div>
                            <div class="img" v-else>
                              <img src="./../../../../assets/images/feedRecord/disabled.svg" alt="">
                            </div>
                            <font>当前在吃</font>
                          </div>
                          <!-- 设为当前在吃 -->
                          <div class="eat" v-else>
                            <div class="img" @click.stop="handleSetNowEat(item.id, item.productDan, item.num, item.pic, item.id)">
                              <img src="./../../../../assets/images/feedRecord/eat_no_checked.png" alt="">
                            </div>
                            <font>当前在吃</font>
                          </div>
                          <div class="nums" v-if="item.showAmountChecked">
                            <span class="minus_symbol"  v-if="item.num > 0" @click.stop="counter($event, 'decrease', item.id, idx, item.using, item.productDan, item.pic)">
                              <img src="./../../../../assets/images/feedRecord/minus.png" alt="">
                            </span>
                            <span class="minus_symbol" v-else>
                              <img src="./../../../../assets/images/feedRecord/disabled_minus.png" alt="">
                            </span>
                            <span class="count"><i class="font">{{item.num}}</i></span>
                            <span class="symbol" v-if="item.num < 99" @click.stop="counter($event, 'increase', item.id, idx, item.using, item.productDan, item.pic)">
                              <img src="./../../../../assets/images/feedRecord/plus.png" alt="">
                            </span>
                            <span class="symbol" v-else>
                              <img src="./../../../../assets/images/feedRecord/disabled_plus.png" alt="">
                            </span>
                          </div>
                          <div class="show_num" v-else @click.stop="showAmount($event, item.id, idx)">
                            <div class="times_sign">
                              <span class="times_sign_box">
                                <img class="times_sign_img" src="./../../../../assets/images/feedRecord/times_sign.svg" alt="">
                              </span>
                              <span class="count">{{item.num}}</span>
                            </div>
                          </div>
                        </div>
                      </dd>
                    </dl>
                  </template>
                </van-card>
                <div :class="['line_bottom', sliderLeftState ? 'slider_left_state' : '']"></div>
                <template #right>
                  <div class="del_img" @click.stop="handleDeleteKc(item.using, item.productDan, item.id, item.pic)">
                    <img src="./../../../../assets/images/feedRecord/del_icon.png" alt="">
                  </div>
                </template>
              </van-swipe-cell>
              </li>
            </ul>
            <div class="perch" v-if="milkInventorData.length < 4 && milkInventorData.length > 0"></div>
            <div v-if="milkInventorData.length > 3" class="pack_up_more" @click.stop="handleShowMore">
              {{moreText}}
              <span>
                <img :class="showMore ? 'rotate' : ''" src="./../../../../assets/images/feedRecord/up.svg" alt="">
              </span>
            </div>
          </div>
          <!-- 为空库存 -->
          <EmptyPage type="inventory_null" v-else>
            <p class="text">粮仓空空如也，快去添加吧～</p>
          </EmptyPage>
          <div class="linef2"></div>
        </div>
        <!--  -->
        <div class="record">
          <div class="record_title">
            <Title>
              <h3 class="title">历史记录</h3>
            </Title>
          </div>
          <div class="screen">
            <!-- 多选选择框 -->
            <div class="scroll">
              <div
                v-for="item in addRecordTabs"
                :key="item.id"
                :class="['sizer', item && item.checked ? 'active' : 'def_active']"
                @click.stop="handleTab(item)"
              >
                <div class="rule">
                  <div class="sum">
                    <img v-if="item && item.checked" src="./../../../../assets/images/feedRecord/active_history_times_sign.png" alt="">
                    <img v-else src="./../../../../assets/images/feedRecord/screen_times_sign.png" alt="">
                    <span class="barrelage">{{ item && item.num }}罐</span>
                  </div>
                  <div class="specifications">
                    {{ item && item.rule }} {{ item && item.weight }}g
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="record_list" v-if="list.length > 0">
            <van-list
              class="reserve-list">
              <div
                class="record_list_item"
                v-for="(item, idx) in list"
                :key="idx"
                :title="item.productName"
              >
              <div class="top_line"></div>
                <div class="record_pro">
                  <font class="weight">{{ item.productName }}</font>
                  <div class="amount">
                    <img class="history_times_sign" src="./../../../../assets/images/feedRecord/history_times_sign.png" alt="">
                    <font class="bucket_num">{{ item.num }}罐</font>
                  </div>
                </div>
                <span class="record_time">{{ item.createTime | timeChange}}</span>
              </div>
            </van-list>
          </div>
          <!-- 无列表数据 -->
          <!-- <EmptyPage type="record_null" v-else>
            <p class="text">今天还没有添加记录哦～</p>
          </EmptyPage> -->
        </div>
        <!-- 轮播 -->
        <div class="slider" v-if="!isImg">
          <van-swipe :autoplay="5000" @change="onChangeSwiper">
            <van-swipe-item
              v-for="(image, index) in sliderImgs"
              :key="index"
              @click.stop="onClickSwiper(image, image.id, index)"
            >
              <img class="slider_img" :src="image.picUrl" />
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
      <!-- Footer -->
        <div class="scanQR">
          <div class="sweep_code btn" @click.stop="sweepCode">
            <font>扫码添加</font><small>(仅飞鹤)</small>
          </div>
          <div
            class="modification_margin btn"
            @click.stop="addMargin"
          >
            <font>手动添加</font>
          </div>
        </div>
    </div>
  </div>
</template>

<script>

import { shareHome } from '@/minxs/shareHome.js'
import feedRecordsApi from "@/utils/axiosApi/feedRecordsApi"
import wx from "weixin-js-sdk"
import feedRecordsUtils from './index.js'
import { is_weixin, throttle, setCookie } from '@/assets/js/common.js';
import { Baby_Granary_Page_View } from '@/assets/js/Exposure';

import EmptyPage from './components/EmptyPage'
import Title from './components/Title'
import $ from 'jquery';

export default {
  name: 'newBabyBarn',
  mixins: [shareHome],
  data() {
    return {
      grading: '',
      kcCur: 0,
      kcTabs: [{
        tit: '全部',
        sign: 'all',
        total: 0,
        id: 0,
      },
      {
        tit: '三段',
        sign: 'S03',
        total: 0,
        id: 3
      },
      {
        tit: '二段',
        sign: 'S02',
        total: 0,
        id: 2
      },
      {
        tit: '一段',
        sign: 'S01',
        total: 0,
        id: 1
      }],
      showMore: false, // 默认显示最多3个
      moreText: '展开更多',
      startX: 0,
			endX: 0,
      startY: 0,
      endY: 0,
      touKcIdx: '',
      showAmountKcIdx: '', // 点击x的id
      jtKcIdx: '', // 点击箭头的id
      delKcIdx: '', // 删除的id
      updateRepPars: { // 加减时传参
        memberId: '',
        id: '',
        specs: '',
        productName: '',
        productDan: '',
        weight: '',
        historyNum: null,
        newWeight: '',
        everydayNum: 0,
      },
      newWeight: '', // 奶粉余量
      historyNum: null, // 增减 1 / -1
      count: null,
      list: [], // 请求数据
      error: false,
      checkedArr: ['S01', 'S02', 'S03'],
      // minNum: null,
      milkPar: {
        crmId: '',
        monthAge: null,
        // minNum: null,
        maxNum: null,
        productDanType: 0,
        state: 0
      },
      MDgetAllKind: 0, // 埋点获取所有种类
      milkInventorData: [], // 库存数据
      isMilkInventor: false, // 是否显示库存
      // delayTimeFlag: true, // 默认穿透 auto 可点击
      // touchDelayTimeFlag: true,
      curIdx: '', // 添加记录的tab id标识
      curKcIdx: '', // 库存每一项的id
      // 添加记录tab
      addRecordTabs: [
        {
          id: 'S01',
          rule: '1段',
          weight: 0,
          num: 0,
          checked: false,
        },
        {
          id: 'S02',
          rule: '2段',
          weight: 0,
          num: 0,
          checked: false,
        },
        {
          id: 'S03',
          rule: '3段',
          weight: 0,
          num: 0,
          checked: false,
        },
      ],
      showAmountId: null, // 默认滑过显示x数量 id
      sliderImgs: [],
      sliderLeftState: false, // 默认左滑旁边的线是有间距的 左滑时通栏
      current: 0,
      isImg: false,
      // toolFeedPoint: {}, // 埋点用到的本地存储的字段
      babyNum: null, // 埋点用到的本地存储的宝宝数量
    }
  },
  components: {
    EmptyPage,
    Title
  },
  computed: {
    sliceMilkInventorData() { // 新宝宝粮仓初始库存记录默认显示三条数据 len: 3
      let len = 3
      if (this.milkInventorData.length <= len || this.showMore) { // 不超3条或显示收起更多时不截取
        return this.milkInventorData
      } else {
        return this.milkInventorData.slice(0, len)
      }
    },
  },
  mounted() {
    this.initParamsData()

    this.initMilkInventory() // 先初始库存页面

    // feedRecordsUtils.isWitchMonth(this.milkPar.monthAge) // 后根据宝宝月龄判断吃几段奶粉

    this.getBanner() // 轮播图

    // 宝宝粮仓页面浏览 埋点
    setTimeout(() => {
      var that = this
      Baby_Granary_Page_View.observe(".baby_barn_page", false, {
        // Baby_Month: that.toolFeedPoint.Baby_Month,
        Baby_Month: that.$route.query.monthAge + '',
        Baby_Bmount: that.babyNum + '',
        Inventory_Kind: that.MDgetAllKind + ''
      })
    }, 2000)
  },
  methods: {
    is_weixin,
    initParamsData() {
      // this.toolFeedPoint = JSON.parse(localStorage.getItem('toolFeedPoint'))
      this.babyNum = JSON.parse(localStorage.getItem('babyNum')) ? JSON.parse(localStorage.getItem('babyNum')) : 1

      let localuserInfo = JSON.parse(localStorage.getItem('userInfo'))
      let month = this.$route.query.monthAge + ''
      this.milkPar.monthAge = month
      this.milkPar.maxNum = this.$route.query.maxNum
      // this.minNum = this.$route.query.minNum
      this.milkPar.crmId = localuserInfo.crm_id

      this.milkPar.productDanType =  JSON.parse(window.sessionStorage.getItem('productDanType'))
      ? JSON.parse(window.sessionStorage.getItem('productDanType')) : this.milkPar.productDanType

      this.kcCur = this.milkPar.productDanType
      this.grading = feedRecordsUtils.isWitchMonth(this.milkPar.monthAge)
      this.everydayNum = (Number(this.milkPar.maxNum)) * 0.14

      this.bus.$on('query', (data) => {
        this.milkPar.monthAge = data.monthAge
        this.milkPar.maxNum = data.maxNum
        // this.minNum = data.minNum
      })
    },
    goBack() { // 返回导航
      this.$router.back()
    },
    handleScroll: throttle(function() { // 获取滚动距顶部的距离，显示

      this.touKcIdx = ''

      this.recoveryMode() // 恢复默认状态

    }, 300),
    leftSliderFn(id) {
      this.sliderLeftState = true

      this.touKcIdx = id

      let obj = this.milkInventorData.find((item) => {
        return item.id == this.touKcIdx
      })
      this.showHidTouchLeftFlags()

      if(this.isAddSubFlagFn()) { // 如果有一项是有加减号的, 就关掉加减变为x
        this.addSubFlaseFlags()
      }

      sensors.track('Baby_Granary_Delete_Inventory_View', {
        // Baby_Month: this.toolFeedPoint.Baby_Month, //当前宝宝月龄
        Baby_Month: this.$route.query.monthAge + '',
        Baby_Bmount: this.babyNum + '', // 宝宝数量
        Inventory_Kind: this.MDgetAllKind + '', // 库存种类数
        Milkpowder_Stage: this.isMDProductDan(obj.productDan), // 粮仓奶粉段位
        Milkpowder_Remainder: this.newWeight + '', // 奶粉余量
        Addition_Type: obj.pic != '' ? '扫码添加' : '手动添加', // 库存添加类型
      })
    },
    rightSliderFn(id) {
      // this.touKcIdx = id

      this.touchLeftFlaseFlag()

      this.sliderLeftState = false
    },
    isAddSubFlagFn() { // 如果有一项是有加减号的
      let addSubFlag = this.milkInventorData.some((item) => {
        return item.showAmountChecked && item.showAmountChecked
      })

      return addSubFlag
    },
    isTouchLeftFlagFn() { // 如果有一项是有左滑效果的
      let touchLeftFlag = this.milkInventorData.some((item) => {
        return item.touchLeft && item.touchLeft
      })

      return touchLeftFlag
    },
    hiddenEle(e) { // 点击使加减号 删除 按钮隐藏
      e.stopImmediatePropagation()

      this.recoveryMode() // 恢复默认状态
    },
    recoveryMode() { // 封装恢复默认状态
      if(this.isAddSubFlagFn()) { // 如果有一项是有加减号的, 就关掉加减变为x
        this.addSubFlaseFlags()
      }

      if(this.isTouchLeftFlagFn()) { // 如果有一项是有左滑效果的, 就把左滑关掉
        this.touchLeftFlaseFlag()
        // this.rightSliderFn()
      }

    },
    counter(e, type, id, idx, using, productDan, pic) {
      let _this = this

      this.touKcIdx = ''

      this.curKcIdx = id

      let obj = this.milkInventorData.find((item) => {
        return item.id == this.curKcIdx
      })

      this.addSubTrueFlags()

      if(this.isTouchLeftFlagFn()) { // 如果有一项是有左滑效果的, 就把左滑关掉

        this.touchLeftFlaseFlag()

      }

      // this.rightSliderFn()

      this.$nextTick(() => {
      if(type == 'decrease') { // 减
      _this.milkInventorData = _this.milkInventorData.map((item) => {
        if (item.id == id) {
          if(item.num > 0) {
            item.num --
            _this.newWeight = (item.num - 1) * obj.specs + ((obj.weight % obj.specs) > 0 ? (obj.weight % obj.specs) : obj.specs)
            _this.newWeight < 0 && (_this.newWeight = 0)
            item.eatDays = parseInt(((_this.newWeight) * 1 / (_this.everydayNum * 1)))
            _this.historyNum = -1

            // 修改库存减 埋点
            sensors.track('Baby_Granary_Modify_Inventory', {
              // Baby_Month: this.toolFeedPoint.Baby_Month, //当前宝宝月龄
              Baby_Month: this.$route.query.monthAge + '',
              Baby_Bmount: this.babyNum + '', // 宝宝数量
              Inventory_Kind: this.MDgetAllKind + '', // 库存种类数
              Addition_Type: pic != '' ? '扫码添加' : '手动添加', // 添加类型
              Milkpowder_Stage: this.isMDProductDan(item.productDan), // 粮仓奶粉段位
              Modify_Type: '减少', // 修改方式
              Is_Eating: (item.using && item.productDan == this.grading) ? true : false, // bool 是否
            })
          }
        }
        return item
      })
      } else { // increase
        _this.milkInventorData = _this.milkInventorData.map((item) => {
          if(item.id == id) {
            if(item.num < 99) {
				      item.num ++
              _this.newWeight = (item.num - 1) * obj.specs + ((obj.weight % obj.specs) > 0 ? (obj.weight % obj.specs) : obj.specs)
              item.eatDays = parseInt(((_this.newWeight) * 1 / (_this.everydayNum * 1)))
              _this.historyNum = 1

              // 修改库存加 埋点
              sensors.track('Baby_Granary_Modify_Inventory', {
                // Baby_Month: _this.toolFeedPoint.Baby_Month, //当前宝宝月龄
                Baby_Month: _this.$route.query.monthAge + '',
                Baby_Bmount: _this.babyNum + '', // 宝宝数量
                Inventory_Kind: _this.MDgetAllKind + '', // 库存种类数
                Addition_Type: pic != '' ? '扫码添加' : '手动添加', // 添加类型
                Milkpowder_Stage: _this.isMDProductDan(item.productDan), // 粮仓奶粉段位
                Modify_Type: '增加', // 修改方式
                Is_Eating: (item.using && item.productDan == _this.grading) ? true : false, // bool 是否
              })
            }
			    }
          return item
          })
        }

        let userInfo = {
          memberId: this.milkPar.crmId,
          weight: this.newWeight,
          historyNum: this.historyNum
        }

        let userPar = {
          id: obj.id,
          specs: obj.specs,
          productName: obj.productName,
          productDan: obj.productDan
        }

        this.updateRepPars = {
          ...this.updateRepPars,
          ...userInfo,
          ...userPar
        }

        feedRecordsApi.postUpdateRepertory({}, {...this.updateRepPars},
        (res) => {
          if(res.code == '200') {
            this.initAddRecord() // 添加记录
          }
        })
      })
    },
    showAmount(e, id, idx) { // 点击默认数量显示加减号

      this.curKcIdx = id

      this.addSubFlags()

      if(this.isTouchLeftFlagFn()) { // 如果有一项是有左滑效果的, 就把左滑关掉

        this.touchLeftFlaseFlag()

        this.$refs[`list${id}`][0].close()

      }
    },
    handleDeleteKc(using, productDan, id, pic) { // 删除库存

      this.delKcIdx = id

      let obj = this.milkInventorData.find((item) => {
        return item.id == this.delKcIdx
      })

      this.newWeightFn(obj)

      if(using && productDan == feedRecordsUtils.isWitchMonth(this.milkPar.monthAge)) {
        this.$toast({
          duration: 1000,
          message: '当前在吃状态不能删除！'
        })
        this.recoveryMode() // 恢复默认状态

        this.$refs[`list${id}`][0].close()


        // 库存删除点击 埋点
        sensors.track('Baby_Granary_Delete_Inventory_Click', {
          // Baby_Month: this.toolFeedPoint.Baby_Month, //当前宝宝月龄
          Baby_Month: this.$route.query.monthAge + '',
          Baby_Bmount: this.babyNum + '', // 宝宝数量
          Inventory_Kind: this.MDgetAllKind + '', // 库存种类数
          Milkpowder_Stage: this.isMDProductDan(productDan), // 粮仓奶粉段位
          Milkpowder_Remainder: this.newWeight + '', // 奶粉余量
          Addition_Type: pic != '' ? '扫码添加' : '手动添加', // 库存添加类型
        })
        return
      }

      // 库存删除点击 埋点
      sensors.track('Baby_Granary_Delete_Inventory_Click', {
        // Baby_Month: this.toolFeedPoint.Baby_Month, //当前宝宝月龄
        Baby_Month: this.$route.query.monthAge + '',
        Baby_Bmount: this.babyNum + '', // 宝宝数量
        Inventory_Kind: this.MDgetAllKind + '', // 库存种类数
        Milkpowder_Stage: this.isMDProductDan(productDan), // 粮仓奶粉段位
        Milkpowder_Remainder: this.newWeight + '', // 奶粉余量
        Addition_Type: pic != '' ? '扫码添加' : '手动添加', // 库存添加类型
      })

      feedRecordsApi.getDelRepertory({id: obj.id}, (res) => {
        if(res.code == '200') {

          this.initMilkInventory() // 库存
          if(this.isTouchLeftFlagFn()) { // 如果有一项是有左滑效果的, 就把左滑关掉

        this.touchLeftFlaseFlag()

        this.$refs[`list${id}`][0].close()

      }
        }
      })
    },
    kcTabsFn(id) { // 判断是哪个库存tab
      this.milkPar.productDanType = id

      window.sessionStorage.setItem('productDanType', JSON.stringify(this.milkPar.productDanType))

      this.initMilkInventory()

      this.addSubFlags()
    },
    addSubFlaseFlags() { // 封装加减号都消失
      let milkInventorData = this.milkInventorData.map((item) => { // 库存数据添加隐藏加减号标识

        item.showAmountChecked = false

        return item
      })

      this.milkInventorData = milkInventorData
    },
    addSubFlags() { // 封装重新赋值给库存加减号标识 public
      let milkInventorData = this.milkInventorData.map((item) => {
        if(item.id == this.curKcIdx) {
          item.showAmountChecked = true
        } else {
          item.showAmountChecked = false
        }
        return item
      })
      this.milkInventorData = milkInventorData
    },
    addSubTrueFlags() { // 封装加减号都显示
      let milkInventorData = this.milkInventorData.map((item) => {
        if(item.id == this.curKcIdx) {
          item.showAmountChecked = true
        }
        return item
      })
      this.milkInventorData = milkInventorData
    },
    showHidTouchLeftFlags() { // 封装左滑时删除按钮显示隐藏
      let milkInventorData = this.milkInventorData.map((ele, index) => {
        if(this.touKcIdx == ele.id) {
          this.$set(ele, 'touchLeft', true)
        } else {
          this.$set(ele, 'touchLeft', false)
        }
        return ele
      })
      this.milkInventorData = milkInventorData
    },
    touchLeftFlaseFlag() { // 封装滑动全为false
      let milkInventorData = this.milkInventorData.map((ele, index) => {
        this.$set(ele, 'touchLeft', false)
        return ele
      })
      this.milkInventorData = milkInventorData
    },
    kcTabChange(id, sign) { // 当前库存切换
      this.showMore = false

      this.kcCur = id

      this.milkInventorData = []

      this.kcTabsFn(this.kcCur)
    },
    handleShowMore() { // 展示更多
      this.showMore = !this.showMore

      this.moreText = this.showMore ? '收起更多' : '展开更多'
    },
    newWeightFn(obj) { // 封装当前项的数量
      this.newWeight = (obj.num - 1) * obj.specs + ((obj.weight % obj.specs) > 0 ? (obj.weight % obj.specs) : obj.specs)
    },
    isMDProductDan(productDan) { // 封装判断根据是哪个段位标识返回段位文字
      if(productDan == 'S03') {
        return '三段'
      } else if(productDan == 'S02') {
        return '二段'
      } else if(productDan == 'S01') {
        return '一段'
      }
    },
    initMilkInventory() { // 获取奶粉库存
      feedRecordsApi.getMilkInventory({ ...this.milkPar }, (res) => {
        if(res.code == '200') {

          let datas = res.data

          this.milkInventorData = res.data.data

          this.touchLeftFlaseFlag()

          this.isMilkInventor = (this.milkInventorData && this.milkInventorData).length > 0 ? true : false // true 有库存显示库存列表

          this.MDgetAllKind = res.data.allNum // true 有库存显示库存列表

          this.initAddRecord() // 添加记录

          let kcTabs = this.kcTabs.map((ele, i) => {
            if(i == 0) {
              ele.total = datas.allNum
            } else if(i == 1) {
              ele.total = datas.S03Num
            } else if(i == 2) {
              ele.total = datas.S02Num
            } else {
              ele.total = datas.S01Num
            }
            return ele
          })
          this.kcTabs = kcTabs
        }
      })
    },
    handleSetNowEat(newId, productDan, num, pic, id) { // 设为当前在吃
      let _this = this

      _this.touKcIdx = ''

      _this.curKcIdx = id

      this.recoveryMode() // 恢复默认状态

      let obj = this.milkInventorData.filter((item) => { // 筛选出当前在吃状态的那一条数据
        return (item.using == true && (item.productDan == feedRecordsUtils.isWitchMonth(this.milkPar.monthAge)))
      })

      if(productDan !== feedRecordsUtils.isWitchMonth(this.milkPar.monthAge)) { // 如果当前这条是匹配月龄吃的段位才可以设为当前在吃状态
      this.$toast({
        duration: 3500,
        message: '抱歉，该奶粉与宝宝月龄不符，无法设为当前在吃'
      })
      // 设为当前在吃 埋点
      sensors.track('Baby_Granary_Set_Currenteating', {
        // Baby_Month: this.toolFeedPoint.Baby_Month, //当前宝宝月龄
        Baby_Month: this.$route.query.monthAge + '',
        Baby_Bmount: this.babyNum + '', // 宝宝数量
        Inventory_Kind: this.MDgetAllKind + '', // 库存种类数
        Addition_Type: pic != '' ? '扫码添加' : '手动添加', // 库存添加类型 有图片就是扫码添加的
        Milkpowder_Stage: this.isMDProductDan(productDan), // 奶粉段位
        Is_Success_failure: false, // 成功/失败
      })
        return
      } else if(num < 1) {
        this.$toast({
          duration: 3500,
          message: '抱歉，该奶粉没有库存，无法设为当前在吃'
        })

        // 设为当前在吃 埋点
        sensors.track('Baby_Granary_Set_Currenteating', {
          // Baby_Month: this.toolFeedPoint.Baby_Month, //当前宝宝月龄
          Baby_Month: this.$route.query.monthAge + '',
          Baby_Bmount: this.babyNum + '', // 宝宝数量
          Inventory_Kind: this.MDgetAllKind + '', // 库存种类数
          Addition_Type: pic != '' ? '扫码添加' : '手动添加', // 库存添加类型
          Milkpowder_Stage: this.isMDProductDan(productDan), // 奶粉段位
          Is_Success_failure: false, // 成功/失败
        })
        return
      }

      feedRecordsApi.getNowEat({id: newId, oldId: obj[0].id
       }, (res) => {

        // 设为当前在吃 埋点
        sensors.track('Baby_Granary_Set_Currenteating', {
          // Baby_Month: this.toolFeedPoint.Baby_Month, //当前宝宝月龄
          Baby_Month: this.$route.query.monthAge + '',
          Baby_Bmount: this.babyNum + '', // 宝宝数量
          Inventory_Kind: this.MDgetAllKind + '', // 库存种类数
          Addition_Type: pic != '' ? '扫码添加' : '手动添加', // 库存添加类型
          Milkpowder_Stage: this.isMDProductDan(productDan), // 奶粉段位
          Is_Success_failure: res.message == '成功' ? true : false, // 成功/失败
        })

        if(res.code == '200') {

            _this.initMilkInventory() // 库存

        }
      })
    },
    handleTab(item) {
      // 点击添加记录TAB
      this.curIdx = item.id
      let addRecordTabs = this.addRecordTabs.map((v, i) => {
        if (this.curIdx == v.id) {
          v.checked = !v.checked
        }
        return v
      })

      this.addRecordTabs = addRecordTabs

      let arr = this.addRecordTabs.filter((ele, index) => {
        return ele.checked == true
      })

      let newArr = []
      if(arr.length > 0) {
        for (let j = 0; j < arr.length; j++) {
          if (arr[j].checked) {
            if (newArr.indexOf(arr[j].id) < 0) {
              newArr.push(arr[j].id)
            }
          } else {
            if (newArr.indexOf(arr[j].id) > -1) {
              newArr = newArr.splice(newArr.indexOf(arr[j].id), 1)
            }
          }
        }
        this.checkedArr = newArr
    }

      if (this.checkedArr.length == 0) {
        this.checkedArr = ['S01', 'S02', 'S03']
      }
      this.initAddRecord()
    },
    // 获取资源表单列表
    initAddRecord() {
      let _this = this
      feedRecordsApi.postAddRecord(
        {},
        {
          crmId: this.milkPar.crmId,
          productDanList: JSON.parse(JSON.stringify(this.checkedArr))
        },
        (res) => {
          if (res.code == '200') {
            let memberProductExtendList = res.data.memberProductExtendList
            // 赋值给添加记录段位tabs数据
            let addRecordTabs = this.addRecordTabs.map((ele, idx) => {
              if (ele.id == 'S01') {
                ele.num = res.data.S01countNum
                ele.weight = res.data.S01countWeight
              } else if (ele.id == 'S02') {
                ele.num = res.data.S02countNum
                ele.weight = res.data.S02countWeight
              } else if (ele.id == 'S03') {
                ele.num = res.data.S03countNum
                ele.weight = res.data.S03countWeight
              }
              return ele
            })

            this.addRecordTabs = addRecordTabs

            _this.list = res.data.memberProductExtendList
          }
        }
      )
    },

    sweepCode() { // 扫码添加
      let _this = this
      this.milkPar.state = 1
      // 扫码添加库存 埋点
      sensors.track('Baby_Granary_Inventory_Addition_Click', {
        // Baby_Month: this.toolFeedPoint.Baby_Month, //当前宝宝月龄
        Baby_Month: this.$route.query.monthAge + '',
        Baby_Bmount: this.babyNum + '', // 宝宝数量
        Inventory_Kind: this.MDgetAllKind + '', // 库存种类数
        Addition_Type: '扫码添加', // 库存添加类型
      })

      window.sessionStorage.setItem('productDanType', JSON.stringify(this.milkPar.productDanType))
      // 扫码添加

      if (is_weixin()) {
        if (!window.localStorage.getItem('isWxScan')) {
          window.localStorage.setItem('isWxScan', true)
        } else {
          // this.wxJsSet.wxShare('sm', '', this)
          wx.scanQRCode({
            needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
            scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
            success: function(res) {
                var result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
                if (result.indexOf(".feihe.com") != -1) {
                    window.location.href = result //扫描后有个链接，然后跳转到该页面
                } else {
                    _this.$toast({
                        duration: 3500,
                        message: '添加失败，请再次扫码或手动添加'
                    })
                }
            }
          })
        }
      } else {
        this.$toast({
          message: '请在微信端打开',
          forbidClick: true,
          duration: 2000,
          context: this
        })
      }
    },
    addMargin() { // 手动添加
      this.milkPar.state = 0

      window.localStorage.setItem('kcTabs', JSON.stringify(this.kcTabs))

      window.sessionStorage.setItem('productDanType', JSON.stringify(this.milkPar.productDanType))

      // 手动添加库存 埋点
      sensors.track('Baby_Granary_Inventory_Addition_Click', {
        // Baby_Month: this.toolFeedPoint.Baby_Month, //当前宝宝月龄
        Baby_Month: this.$route.query.monthAge + '',
        Baby_Bmount: this.babyNum + '', // 宝宝数量
        Inventory_Kind: this.MDgetAllKind + '', // 库存种类数
        Addition_Type: '手动添加' // 库存添加类型
      })

      this.$router.push({
        path: '/newInventoryAdd',
        query: {
          state: this.milkPar.state,
          monthAge: this.milkPar.monthAge,
          maxNum: this.milkPar.maxNum,
          // minNum: this.minNum,
          productDanType: this.milkPar.productDanType,
          MDgetAllKind: this.MDgetAllKind
        }
      })
    },
    getBanner() { // 获取轮播图
      feedRecordsApi.getFeedBanner({ moduleType: 3 }, (res) => {
        if (res.code == '200') {
          this.sliderImgs = res.data

          if(this.sliderImgs.length < 1 || this.sliderImgs == '') {
            this.isImg = true
          }
        }
      })
    },
    onChangeSwiper(index) { // 改变轮播索引值
      this.current = index
    },
    onClickSwiper(item, index, location) { // 点击swipe
        this.current = index

        if(item.jumpUrl !== '') {
          window.location.href = item.jumpUrl
        }
    },
    destroyed() {
      clearTimeout(this.timer1)

      clearTimeout(this.timer2)
    }
  }
}
</script>

<style lang="less" scoped>
.baby_barn_page {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #F2F2F2;;
  .baby_barn_content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #F2F2F2;
    position: relative;
    padding-bottom: 68px;
    box-sizing: border-box;
    ::-webkit-scrollbar {
      display: none;
    }
    .header {
      padding: 10px 8px 0px 8px;
      color: #333333;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #FFFFFF;
    }
    .gobackBtn {
      z-index: 100;
      position: fixed;
      width: 26px;
      height: 26px;
      top: 17px;
      left: 20px;
      overflow: hidden;
      img {
        width: 26px;
        height: 26px;
      }
    }
    .content_top {
      width: 100%;
      height: auto;
      flex: 1;
      overflow-y: scroll;
      padding: 10px 12px;
      box-sizing: border-box;
      .baby_barn_story {
        width: 100%;
        border-radius: 8px;
        overflow: hidden;
        background: #FFFFFF;
      }
      // .linef2 {
      //   width: 100%;
      //   height: 10px;
      //   background: #F2F2F2;
      // }
      .all_tab {
        width: 100%;
        height: 24px;
        margin-top: 20px;
        // margin-bottom: 10px;
        padding: 0 8px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        background: #FFFFFF;
        span {
          height: 20px;
          font-size: 12px;
          font-weight: 500;
          color: #333333;
          line-height: 20px;
          &.cur_active {
            color: #FB6E7E;
            font-size: 14px;
            // height: 20px;
            // line-height: 20px;
            &::after {
              content: '';
              display: block;
              height: 2px;
              width: 10px;
              background: #FB6E7E;
              border-radius: 1px;
              text-align: center;
              margin: 2px auto 0;
            }
          }
        }
      }
    }
    .slider {
      // 轮播图
      width: 100%;
      height: 130px;
      margin-top: 10px;
      position: relative;
      background: #FFFFFF;
      border-radius: 8px;
      overflow: hidden;
      /deep/ .van-swipe {
        width: 100%;
        height: 130px;
        display: flex;
        flex-direction: column;
        background: #FFFFFF;
      }
      .van-swipe /deep/ .van-swipe-item {
        width: 100%;
        height: 130px;
        background: pink;
      }
      .van-swipe /deep/ .van-swipe-item .slider_img {
        width: 100%;
        height: 130px;
        display: inline-block;
      }
      .van-swipe /deep/ .van-swipe__indicators {
        height: 12px;
        position: absolute;
        bottom: 0;
        display: flex;
        padding-top: 4px;
        padding-bottom: 4px;
        box-sizing: border-box;
      }
      .van-swipe /deep/ .van-swipe__indicators .van-swipe__indicator {
        width: 4px;
        height: 4px;
        line-height: 4px;
        background: #FFFFFF;
        // margin-left: 4px;
      }
      .van-swipe /deep/ .van-swipe__indicators .van-swipe__indicator--active {
        width: 12px;
        height: 4px;
        background: #FB6E7E;
        border-radius: 2px;
      }
    }
    .scanQR {
      width: 100%;
      height: 68px;
      background: #ffffff;
      display: flex;
      position: fixed;
      z-index: 100;
      bottom: 0;
      left: 0;
      padding: 10px 32px 14px;
      box-sizing: border-box;
      box-shadow: 0px 0px 4px 0px #EEEEEE;
      .btn {
        width: 140px;
        height: 44px;
        background: #FB6E7E;
        border-radius: 22px;
        display: flex;
        justify-content: center;
        align-items: center;
        &.sweep_code {
          margin-right: 31px;
          small {
            font-size: 12px;
            font-weight: 400;
            line-height: 44px;
            align-self: flex-end;
            color: #FFFFFF;
          }
        }
        > font {
          font-size: 18px;
          font-weight: 400;
          line-height: 44px;
          color: #FFFFFF;
        }
      }
    }
  }
  .current_inventory {
    width: 100%;
    background: #FFFFFF;
    // margin-top: 20px;
    overflow: hidden;
    .inventory_list {
      width: 100%;
      background: #FFFFFF;
      overflow: hidden;
        .left_slider {
          width: 100%;
          background: #FFFFFF;
          overflow: hidden;
          .van-swipe-cell {
            overflow: hidden;
            position: relative;
            .van-swipe-cell__wrapper {
              overflow: hidden;
              .van-swipe-cell__right {
                width: 78px;
                height: 100%;
                overflow: hidden;
                .del_img {
                  width: 78px;
                  height: calc(100% - 1px);
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  background: #FF3B30;
                  >img {
                    width: 20px;
                    height: 21px;
                  }
                }
              }
            }
          }
          .van-card {
            background: #FFFFFF;
            padding: 0px 8px;
            box-sizing: border-box;
          }
          .line_bottom {
            width: calc(100% - 16px);
            position: absolute;
            bottom: 0;
            left: 8px;
            right: 8px;
            height: 1px;
            background: #EEEEEE;
            transform: scaleY(0.5);
            &.slider_left_state {
              width: 100%;
            }
          }
          .dl {
            width: 100%;
            display: flex;
            background: #FFFFFF;
            z-index: 99;
            padding: 10px 0px;
            box-sizing: border-box;
            .brand_img {
              width: 80px;
              height: 80px;
              padding: 5px;
              box-sizing: border-box;
              position: relative;
              ::after {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                border: 1px solid #EEEEEE;
                box-sizing: border-box;
                width: 200%;
                height: 200%;
                border-radius: 8px;
                transform: scale(0.5);
                transform-origin: left top;
                overflow: hidden;
              }
              .pic {
                width: 70px;
                height: 70px;
                >img {
                  width: 70px;
                  height: 70px;
                }
              }
            }
            .brand_explain {
              width: 100%;
              flex: 1;
              padding-left: 8px;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              .title {
                width: 100%;
                display: flex;
                padding-right: 17px;
                box-sizing: border-box;
                h6 {
                  width: 100%;
                  height: 20px;
                  font-size: 14px;
                  font-weight: 500;
                  color: #333333;
                  line-height: 20px;
                  word-wrap: break-word;
                  overflow : hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                }
              }
              .tips {
                margin-top: 10px;
                .weight {
                  .remind {
                    background: #FFF0F2;
                    padding: 1px 10px;
                    box-sizing: border-box;
                    margin-right: 5px;
                    margin-top: 1px;
                    border-radius: 12px;
                    overflow: hidden;
                    font {
                      font-size: 8px;
                      font-weight: 400;
                      color: #FF7181;
                      line-height: 10px;
                    }
                  }
                  .specification {
                    font-size: 10px;
                    font-weight: 400;
                    color: #999999;
                    height: 14px;
                    line-height: 14px;
                  }
                  .balance {
                    font-size: 10px;
                    font-weight: 400;
                    color: #999999;
                    margin-left: 5px;
                    height: 14px;
                    line-height: 14px;
                    small {
                      color: #FB6E7E;
                      margin: 0 3px;
                      font-size: 10px;
                    }
                  }
                }
              }
              .eat_days {
                display: flex;
                justify-content: space-between;
                margin-top: 10px;
                height: 18px;
                .eat {
                  height: 18px;
                  display: flex;
                  align-items: center;
                  .img {
                    width: 12px;
                    height: 12px;
                    overflow: hidden;
                    >img {
                      max-width: 12px;
                      max-height: 12px;
                    }
                  }
                  font {
                    font-size: 12px;
                    font-weight: 400;
                    color: #999999;
                    line-height: 18px;
                    margin-left: 4px;
                    font-weight: 400;
                  }
                }
                .show_num {
                  width: 40px;
                  height: 17px;
                  background: #F6F6F6;
                  border-radius: 4px;
                  display: flex;
                  padding: 2px 0px 3px 0;
                  box-sizing: border-box;
                  justify-content: center;
                  align-items: center;
                  .times_sign {
                    height: 12px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-bottom: 2px;
                    .times_sign_box {
                      height: 12px;
                      .times_sign_img {
                        align-self: flex-end;
                        width: 5px;
                        height: 5px;
                      }
                    }
                    .count {
                      height: 12px;
                      font-size: 12px;
                      font-weight: 500;
                      color: #333333;
                      margin-left: 2px;
                    }
                  }
                }
              }
              .nums {
                height: 18px;
                display: flex;
                align-items: center;
                .symbol {
                  width: 18px;
                  height: 18px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  padding-left: 6px;
                  box-sizing: border-box;
                  >img {
                    width: 12px;
                    height: 12px;
                  }
                }
                .minus_symbol {
                  width: 18px;
                  height: 18px;
                  padding-right: 6px;
                  box-sizing: border-box;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  >img {
                    width: 12px;
                    height: 2px;
                  }
                }
                .count {
                  width: 40px;
                  height: 18px;
                  background: #F6F6F6;
                  border-radius: 4px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  line-height: 18px;
                  .font {
                    font-style: normal;
                    font-size: 12px;
                    font-weight: 500;
                    color: #333333;
                    margin-top: 1px;
                  }
                }
              }
              .name {
                font-size: 14px;
                font-weight: 500;
                color: #333333;
                line-height: 20px;
              }
              p {
                height: 18px;
                font-size: 12px;
                color: #999999;
                line-height: 18px;
                margin: 12px 0;
              }
              .detailed_description {
                span {
                  height: 18px;
                  font-size: 12px;
                  color: #999999;
                  line-height: 18px;
                  > em {
                    font-style: normal;
                    color: #fb9580;
                  }
                }
              }
            }
          }
          .del {
            flex-shrink: 0;
            width: 78px;
            position: absolute;
            right: 1px;
            top: 1px;
            bottom: 1px;
            background:#FF3B30;
            border-radius: 0px 8px 8px 0;
            box-sizing: border-box;
            z-index: 9;
            display: flex;
            justify-content: center;
            align-items: center;
            &.moveScroll {
              background:#FFFFFF;
            }
            .delayTime {
              pointer-events: none;
            }
            span {
              width: 20px;
              height: 20px;
              >img {
                width: 20px;
                height: 20px;
              }
            }
          }
        }
    }
    .perch {
      margin-top: 13px;
      margin-bottom: 10px;
      height: 2px;
    }
    .pack_up_more {
      margin-top: 17px;
      margin-bottom: 14px;
      text-align: center;
      height: 17px;
      font-size: 12px;
      font-weight: 400;
      color: #FB6E7E;
      line-height: 17px;
      span {
        width: 10px;
        height: 14px;
        margin-left: 5px;
        padding: 4px 0 6px 0;
        box-sizing: border-box;
        >img {
          width: 10px;
          height: 6px;
          margin-top: -2px;
        }
        .rotate {
          transform: rotateX(180deg);
        }
      }
    }
  }
  .text {
    height: 17px;
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    line-height: 17px;
  }
  .record {
    width: 100%;
    background: #FFFFFF;
    margin-top: 10px;
    border-radius: 8px;
    overflow: hidden;
    ::-webkit-scrollbar {
      display: none;
    }
    .record_title {
      padding: 10px 10px 20px;
      box-sizing: border-box;
    }
    .screen {
      width: 100%;
      padding: 0 7px 9px;
      box-sizing: border-box;
      overflow-x: scroll;
      .scroll {
        width: 100%;
        display: flex;
        justify-content: space-between;
      }
      .sizer {
        width: 33.33%;
        // width: 100px;
        padding: 4px 0 3px;
        box-sizing: border-box;
        text-align: center;
        border-radius: 4px;
        overflow: hidden;
        margin-right: 17px;
        &:nth-last-of-type(1) {
          margin-right: 0;
        }
        &.def_active {
          border: 1px solid #EEEEEE;
        }
        &.active {
          height: 100%;
          background: url('./../../../../assets/images/feedRecord/select_border_bg.png') no-repeat;
          background-size: 100% 100%;
          .rule {
            .sum {
              .barrelage {
                color: #FB6E7E;
              }
            }
            .specifications {
              color: #FF7181;
            }
          }
        }
        .rule {
          .sum {
            >img {
              width: 8px;
              height: 8px;
            }
            .barrelage {
              height: 22px;
              font-size: 16px;
              font-weight: bold;
              color: #333333;
              line-height: 22px;
              margin-left: 2px;
            }
          }
          .specifications {
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            line-height: 20px;
          }
        }
      }
    }
    // .reserve-list {
    //   width: 100%;
    //   margin-top: 9px;
    // }
    .record_list {
      width: 100%;
      padding: 0 8px;
      box-sizing: border-box;
      // margin-top: 1px;
      // position: relative; // 点击事件失效的原因
      // z-index: -1;
      .record_list_item {
        width: 100%;
        display: flex;
        justify-content: space-between;
        position : relative;
        padding: 10px 0;
        box-sizing: border-box;
        position: relative;
        .top_line {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 1px;
          background: #EEEEEE;
          transform: scaleY(0.5);
        }
      }
    }
    // .reserve-list.van-list /deep/ .van-list__finished-text {
    //   height: 90px;
    //   padding: 0;
    //   display: flex;
    //   justify-content: center;
    //   align-items: center;
    // }
    .reserve-list.van-list .record_list_item .record_pro {
      flex: 1;
      // line-height: 46px;
      display: flex;
      // margin: 13px 0;
      .weight {
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        flex: 1;
        font-weight: 400;
      }
      .amount {
        width: 134px;
        height: 20px;
        padding-left: 17px;
        box-sizing: border-box;
        .history_times_sign {
          width: 8px;
          height: 8px;
          vertical-align: middle;
        }
        .bucket_num {
          height: 20px;
          font-size: 14px;
          font-weight: 400;
          color: #999999;
          line-height: 20px;
          margin-left: 2px;
        }
      }
    }
    .reserve-list.van-list .record_list_item .record_time {
      width: 70px;
      text-align: right;
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
    }
  }
}
</style>
